var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrangeArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 121,
    height: 127,
    viewBox: "0 0 121 127",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M113.437.1c-27.3 4.636-49.554 25.488-66.502 46.163-13.786 16.818-24.893 36.092-29.314 57.248-.06-.16-.132-.317-.19-.479a93.481 93.481 0 0 1-4.227-15.574c-1.876-10.367-1.71-21.136.261-31.47 1.44-7.547-10.123-10.78-11.57-3.19-2.56 13.406-2.566 26.975.222 40.355 1.381 6.625 3.527 13.044 6.237 19.24 2.437 5.572 4.693 10.976 10.244 13.685.41.236.844.407 1.285.547.18.062.358.114.533.157.047.011.094.025.141.035.5.11.976.153 1.424.126 1.927.09 3.905-.684 5.267-2.712 10.22-15.208 25.3-26.615 42.69-32.364 7.296-2.413 4.17-14.005-3.19-11.57-13.869 4.583-26.296 12.13-36.613 22.075 4.49-18.043 14.413-34.608 26.338-48.895C72.09 34.77 91.718 15.902 116.627 11.67c7.598-1.29 4.376-12.856-3.19-11.57",
    fill: "#F55725",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrangeArrow);
export default __webpack_public_path__ + "static/media/orange_arrow.12d6b9bbc894075af227c0b91e0e348f.svg";
export { ForwardRef as ReactComponent };